import styled from 'styled-components'

export const PassButton = styled.button`
  position: absolute;
  right: 6px;
  top: 55%;
  transform: translateY(-50%);
  z-index: 2;
`
